import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    details: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Error message displayed when the upload location is not found */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useOnResourceSelect.title?c=3esfmv5fkzd5m", defaultMessage: "Upload location not found." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message details displayed when the upload location is not found */
            details: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useOnResourceSelect.details?c=pdwxrauu2rs6", defaultMessage: "Please use a different upload location." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
